@if (displayMode() === 'edit') {
    <mulo-context-frame
        (close)="handleFormClose()"
        (open)="handleFormOpen()"
        [btnLabel]="'research.portal.entityLocations.addItem' | translate"
        [isOpen]="formMode() === 'edit' || formMode() === 'add'"
    >
        <form (ngSubmit)="handleSubmit()" [formGroup]="form">
            <div class="fields-grouping">
                <mat-form-field class="is-comfortably-readable">
                    <mat-label>{{ 'research.portal.entityLocations.address1' | translate }}</mat-label>
                    <input formControlName="address1" matInput />
                    <mat-error>{{ 'research.portal.entity.field.error.limit.max' | translate }}</mat-error>
                </mat-form-field>
                <mat-form-field class="is-comfortably-readable">
                    <mat-label>{{ 'research.portal.entityLocations.address2' | translate }}</mat-label>
                    <input formControlName="address2" matInput />
                    <mat-error>{{ 'research.portal.entity.field.error.limit.max' | translate }}</mat-error>
                </mat-form-field>
            </div>
            <div class="fields-grouping">
                <mat-form-field class="is-comfortably-readable">
                    <mat-label>{{ 'research.portal.entityLocations.city' | translate }}</mat-label>
                    <input formControlName="city" matInput />
                    <mat-error>{{ 'research.portal.entity.field.error.limit.max' | translate }}</mat-error>
                </mat-form-field>
                <mat-form-field class="is-comfortably-readable">
                    <mat-label>{{ 'research.portal.entityLocations.state' | translate }}</mat-label>
                    <input formControlName="state" matInput />
                    <mat-error>{{ 'research.portal.entity.field.error.limit.max' | translate }}</mat-error>
                </mat-form-field>
            </div>
            <div class="fields-grouping">
                <mat-form-field class="is-comfortably-readable">
                    <mat-select
                        formControlName="countryCode"
                        placeholder="{{ 'research.portal.entityLocations.country' | translate }}"
                    >
                        @for (country of countries(); track country) {
                            <mat-option [value]="country.code">{{
                                (country.code | translate) || country.name
                            }}</mat-option>
                        }
                    </mat-select>
                    @if (form?.get('countryCode')?.invalid) {
                        <mat-error [innerHTML]="form?.get('countryCode').errors | errorTranslate"></mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-actions">
                <button
                    [disabled]="form?.pristine || submitInProgress() || !form?.valid"
                    class="is-tight margin-left-sm"
                    mat-raised-button
                    type="submit"
                >
                    {{
                        (formMode() === 'add'
                            ? 'research.portal.entityLocations.submitAdd'
                            : 'research.portal.entityLocations.sumbitSave'
                        ) | translate
                    }}
                </button>
            </div>
        </form>
    </mulo-context-frame>
}

@if (items()?.length) {
    <mat-list
        [attr.aria-label]="ariaLabel()"
        [attr.aria-labelledby]="ariaLabelledBy()"
        class="mulo-elevation-list"
        role="list"
    >
        @for (location of items() | slice: 0 : itemLimit(); track location; let i = $index) {
            <mulo-action-list-item
                @growInAnimation
                [disabled]="i == itemInEdit()"
                [moreBtnLabel]="'research.aria.output.list.menu.more.options' | translate"
                class="mulo-elevation-list-item is-wrapping"
                role="listitem"
            >
                <mat-icon aria-hidden="true" matListItemIcon svgIcon="map-marker"></mat-icon>
                @if (location?.address1) {
                    <div class="semibold" matLine>
                        {{ location.address1 }}
                    </div>
                }
                @if (location?.address2) {
                    <div matLine>
                        {{ location.address2 }}
                    </div>
                }
                <div class="smaller-text" matLine>
                    @for (
                        part of [
                            location?.city,
                            location?.state,
                            location.displayCountry ?? (location.countryCode | translate)
                        ] | arrayClean;
                        track part;
                        let isLast = $last
                    ) {
                        <span>{{ part }}</span>
                        @if (!isLast) {
                            ,
                        }
                    }
                </div>
                @if (displayMode() === 'edit') {
                    <mulo-action-list-item-action
                        (actionEvent)="setForm(i)"
                        [icon]="media.is('gt-sm') ? 'pencil' : null"
                        [labels]="[
                            'research.aria.edit.button' | translate: { value: location.address1 || location.address2 }
                        ]"
                        type="icon-btn"
                    ></mulo-action-list-item-action>
                }
                @if (displayMode() === 'edit') {
                    <mulo-action-list-item-action
                        (actionEvent)="removeItem(i)"
                        [icon]="media.is('gt-sm') ? 'close' : null"
                        [labels]="[
                            'research.aria.deposit.portion.remove'
                                | translate: { value: location.address1 || location.address2 }
                        ]"
                        type="icon-btn"
                    ></mulo-action-list-item-action>
                }
            </mulo-action-list-item>
        }
    </mat-list>
}
@if (items()?.length > itemLimit()) {
    <div class="show-the-rest">
        <button (click)="resetItemLimit()" @opacityOutAnimation class="has-icon" color="primary" mat-button>
            <mat-icon svgIcon="chevron-down"></mat-icon>
            {{ 'research.portal.fulldisplay.details.showTheRest' | translate }}
        </button>
    </div>
}
